import React, { PureComponent } from 'react'
import './styles.css'

export default class CoinRow extends PureComponent {

  render(){
    const { filter, setFilterString } = this.props

    return<fb className='coinsFilterMain'>
      <input
        className='filterInput'
        style={filter ? {borderColor: 'white'} : {}}
        type='text'
        value={filter}
        onChange={(e) => { setFilterString(e.target.value) }} placeholder='search...' />
    </fb>
  }
}



// WEBPACK FOOTER //
// ./src/containers/coinslist/coinsFilter/index.js